<template>
  <el-dialog
    :visible.sync="isShow"
    :title="configOptions.attrs.title || title"
    :closeOnClickModal="
      configOptions.attrs.closeOnClickModal || closeOnClickModal
    "
    :width="configOptions.attrs.width || width"
    :custom-class="configOptions.attrs.customClass || customClass"
    v-bind="configOptions.attrs"
  >
    <slot v-if="configOptions.isDefaultMode"></slot>
    <div v-else class="dialog-main">
      <p class="dialog-main-title">
        {{ configOptions.contentConfig.title || contentConfig.contentTitle }}
      </p>
      <ul class="dialog-main-describes">
        <li
          class="dialog-main-describes-item"
          :key="describe"
          v-for="describe in configOptions.contentConfig.describes"
        >
          {{ describe }}
        </li>
      </ul>
      <slot name="otherContent"></slot>
    </div>
    <div
      slot="footer"
      class="dialog-footer-new"
      v-if="configOptions.footerList && configOptions.footerList.length"
    >
      <div class="dialog-footer-new-list">
        <div
          class="dialog-footer-new-list-item"
          :key="index"
          v-for="(item, index) in configOptions.footerList"
        >
          <slot v-if="item.slotName" :name="item.slotName"></slot>
          <el-button
            v-else-if="item.isShowBtn"
            @click="
              () => {
                customClick(item.click)
              }
            "
            v-bind="item.options"
          >
            <slot
              v-if="item.options.slotName"
              :name="item.options.slotName"
            ></slot>
            <span v-else>{{ item.text }}</span>
          </el-button>
        </div>
      </div>
      <div v-if="configOptions.isShowClose || isShowClose" class="close-dialog">
        <el-button class="dialog-footer-close" @click="close">{{
          configOptions.closeText || closeText
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogWrapUpgrade',
  props: {
    configOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShow: false,
      width: 'auto',
      title: '标题',
      customClass: 'self-dialog-new',
      closeOnClickModal: true,
      isShowClose: false,
      closeText: '关闭',
    }
  },
  watch: {
    isShow(val) {
      this.$emit(val ? 'open' : 'close')
    },
  },
  methods: {
    customClick(cb) {
      cb()
    },
    // 展示弹框
    // eslint-disable-next-line vue/no-unused-properties
    showDialog() {
      this.isShow = true
    },
    // 关闭弹框
    close() {
      this.isShow = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.self-dialog-new {
  .el-dialog__footer {
    .dialog-footer-new {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      &-list {
        display: flex;
        align-items: center;
        &-item {
          margin-left: 8px;
        }
        &-item:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.dialog-main {
  margin-bottom: 8px;
  &-title {
    margin-top: 0;
    line-height: 26px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #5d5d5d;
    margin-bottom: 16px;
  }
  &-describes {
    list-style: none;
    padding: 0;
    margin: 0;
    &-item {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      margin-bottom: 4px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #5d5d5d;
    }
    &-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
